import React, { useState } from "react";
import Body from "./Body";

const Events = () => {
  const [filter, setFilter] = useState({
    gender: "all",
  });
  const [classesFilter, setClassesFilter] = useState([]);
  const [subjectInputsContainerCount, setSubjectInputsContainerCount] =
    useState(1);
  const [programAddModal, setProgramAddModal] = useState(false);
  const [eventViewerModal, setEventViewerModal] = useState(false);
  const _this = {
    filter,
    setFilter,
    classesFilter,
    setClassesFilter,
    subjectInputsContainerCount,
    setSubjectInputsContainerCount,
    programAddModal,
    setProgramAddModal,
    eventViewerModal,
    setEventViewerModal,
  };
  return <Body {..._this} />;
};

export default Events;
